// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"8610278a","110":"c1ba390f","178":"1b8db79f","218":"7d6bd94e","233":"9c2d2fe6","854":"c670772d","869":"35c50e78","953":"cd516df6"}[chunkId] + ".chunk.js";
};